import React from 'react';
import './Home.css';

const Home = () => {
  return (
    <div className="home-container">
      <div className="home-content">
        <h1>Number Paint: Coloring App</h1>
        <p>
          Transform ordinary images into interactive paint-by-number masterpieces.
          Upload images, use the camera, or choose from our pre-built collection!
        </p>
      </div>
    </div>
  );
};

export default Home;
